import TelegramSetup from '@/components/TelegramSetup';

export function TelegramTab({ hotelId }) {
  return (
    <div className="space-y-6" data-testid="owner-telegram-content">
      <div>
        <h2 className="text-2xl font-bold heading-font mb-2">Telegram Integration</h2>
        <p className="text-muted-foreground">Connect your hotel to Telegram for instant notifications</p>
      </div>
      
      <TelegramSetup hotelId={hotelId} />
    </div>
  );
}
